export const ApplicationConstant = {
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
}
